import fetch from '@/utils/fetch';
import * as API from '@/commons/http-api';
import { Toast } from 'antd-mobile';
/**
 * 示例模块
 */
export default {
  namespace: 'initiatorMeetingDetails',
  state: {
    switchCheck: false,
    dataSource: [],
    meetingStatus: '',
    applyInfoList: [],
    signInfoList: [],
    totalApply: 0,
    totalSign: 0,
  },
  reducers: {
    getApplyInfoData(state, action) {
      if (action.pageNo === 1) {
        state.applyInfoList = [];
      }
      return {
        ...state,
        applyInfoList:
          state.applyInfoList.length !== 0
            ? state.applyInfoList.concat(action.payload)
            : action.payload,
        totalApply: action.total,
      };
    },
    getSignInfoData(state, action) {
      if (action.pageNo === 1) {
        state.signInfoList = [];
      }
      return {
        ...state,
        signInfoList:
          state.signInfoList.length !== 0
            ? state.signInfoList.concat(action.payload)
            : action.payload,
        totalSign: action.total,
      };
    },
    setDataSource(state, action) {
      return {
        ...state,
        dataSource: action.payload,
      };
    },
  },
  effects: {
    *getDataSource(action, { put }) {
      const { meetingId, callback = () => {} } = action.payload;
      const res = yield fetch.get(API.MEETING_DATAILS + '?meetingId=' + meetingId);
      if (res.errorType && res.errorType === 'ERROR') {
      } else {
        yield put({
          type: 'setDataSource',
          payload: res.data,
        });
        if (callback && typeof callback === 'function') {
          callback();
        }
      }
    },
    *getApplyInfo(action, { put }) {
      const { params } = action.payload;
      const res = yield fetch.post(API.MEETING_APPLY_INFO, params);
      if (res.errorType && res.errorType === 'ERROR') {
        return Toast.fail(res.message);
      } else {
        yield put({
          type: 'getApplyInfoData',
          payload: res.data.records,
          total: res.data.total,
          pageNo: params.pageNum,
        });
      }
    },
    *getSignInfo(action, { put }) {
      const { params } = action.payload;
      const res = yield fetch.post(API.MEETING_SIGN_INFO, params);
      if (res.errorType && res.errorType === 'ERROR') {
        return Toast.fail(res.message);
      } else {
        yield put({
          type: 'getSignInfoData',
          payload: res.data.records,
          total: res.data.total,
          pageNo: params.pageNum,
        });
      }
    },
  },
};
